import React from 'react';
import styled from 'styled-components';
import { BaseButtonLinkWrapper, ButtonLinkProps } from './BaseButtonLink';
import { PrimaryStyles, StyledPrimaryButtonProps } from './PrimaryButton';

type StyledPrimaryButtonLinkProps = StyledPrimaryButtonProps;

export type PrimaryButtonLinkProps = ButtonLinkProps &
  Partial<StyledPrimaryButtonLinkProps>;

const PrimaryButtonLinkWrapper = styled(
  BaseButtonLinkWrapper
)<StyledPrimaryButtonLinkProps>`
  a {
    ${PrimaryStyles};
  }
`;

export const PrimaryButtonLink: React.FC<PrimaryButtonLinkProps> = ({
  contextColor = 'white',
  fullWidth = false,
  size = 'medium',
  children,
}) => {
  return (
    <PrimaryButtonLinkWrapper
      size={size}
      fullWidth={fullWidth}
      contextColor={contextColor}
    >
      {children}
    </PrimaryButtonLinkWrapper>
  );
};
